module.exports = __webpack_public_path__ + "img/Nikolaos-Karaiskakis.ccab483f.jpg";